import React, { useState } from "react";
import Navbars from "../components/Navbar/Navbars";
import Footer from "../components/Footer/Footer";
import Director from "./Directors/Director";
// Adjust import path if necessary

// Each service component’s content (details and image)

const Board = () => {
  return (
    <div className="services-page">
      <Navbars />
      <Director />

      <Footer />
    </div>
  );
};

export default Board;
